import { IIconClassNameProps, IIconColorProps } from "../../interfaces/IIconProps";
import styles from "./Icon.module.css";

export default ({ color, className }: IIconColorProps & IIconClassNameProps) => (
    <svg className={[styles.icon, className].join(" ")} xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
        <path d="M10.2 10.2L1 19.3V1H10.2V10.2Z" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
        <path d="M19.3 10.2001H10.2V19.3001H19.3V10.2001Z" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
    </svg>
);